<template>
  <div class="beneficiaries">
    <v-form>
      <v-row>
        <v-col cols="12">
          <v-btn
            depressed
            color="primary"
            :disabled="!canEditBeneficiary"
            @click="editBeneficiary(null)"
            >New Beneficiary</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="beneficiaries"
            dense
            class="searchResults"
            item-key="BeneficiaryID"
            :items-per-page="-1"
            :loading="loading"
            loading-text="Loading beneficiaries..."
            :single-select="true"
            :calculate-widths="true"
            @click:row="editBeneficiary"
          >
          </v-data-table>

          <Sidebar
            :isShown="isSidebarShown"
            :isNew="isNew"
            :formElements="formElements"
            :sidebarName="sidebarName"
            :isFormValid="isFormValid"
            :actionsDisabled="!canEditBeneficiary"
            @form-validity="isFormValid = $event"
            @delete="onDelete"
            @cancel="cancelChanges"
            @save="saveChanges"
          >
          </Sidebar>
        </v-col>
      </v-row>
    </v-form>
    <Dialog ref="confirmationDialog" v-model="dialog" />
  </div>
</template>

<script>
import Sidebar from '@/components/layout/Sidebar.vue';
import Utils from '@/utils.js';
import Dialog from '../../components/layout/Dialog.vue';

export default {
  name: 'Search',
  components: { Sidebar, Dialog },

  data() {
    return {
      dialog: false,
      currentPlan: 0,
      loading: false,
      isSidebarShown: false,
      sidebarName: 'beneficiary',
      formElements: [],
      allElements: [],
      headers: [
        { text: 'Title', value: 'Title' },
        { text: 'Surname', value: 'Surname' },
        { text: 'Forename', value: 'FirstName' },
        { text: 'Beneficiary Type', value: 'BeneficiaryType' },
        { text: 'Date of Birth', value: 'DobString' },
      ],
      beneficiaries: [],
      selectedBeneficiary: null,
      isFormValid: false,
    };
  },

  computed: {
    memberId() {
      return this.$store.state.selectedMemberId;
    },
    isNew() {
      if (this.selectedBeneficiary) return false;
      return true;
    },
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    canEditBeneficiary() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  watch: {
    memberId() {
      this.getBeneficiaries();
    },
  },

  created() {
    this.getHeaders();
  },

  mounted: function () {
    if (!this.memberId) {
      this.$store.commit('setNotificationMessage', {
        type: 'info',
        text: 'Please, select member',
      });
      this.$router.push({ path: '/' });
    } else {
      this.getForm('Beneficiaries');
      this.$root.currentPage = 'Beneficiaries';
    }
  },

  methods: {
    editBeneficiary(item) {
      if (!item && !this.canEditBeneficiary) return;
      this.isSidebarShown = true;
      if (item) {
        this.getBeneficiary(item.BeneficiaryID);
      } else {
        this.formElements.forEach((el) => (el.Value = ''));
        this.selectedBeneficiary = null;
      }
    },

    cancelChanges() {
      this.isSidebarShown = false;
      this.selectedBeneficiary = false;
    },

    saveChanges() {
      if (this.isFormValid) {
        this.isSidebarShown = false;
        if (this.isNew) {
          this.addBeneficiary();
        } else {
          this.updateBeneficiary();
        }
      }
    },

    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.deleteBeneficiary();
      } catch (err) {
        console.log(err);
      }
    },

    async addBeneficiary() {
      const newBeneficiary = {};
      this.allElements.forEach((el) => {
        newBeneficiary[el.FieldName] = el.Value;
      });
      this.formElements.forEach((el) => {
        newBeneficiary[el.FieldName] = el.Value;
      });
      newBeneficiary.BeneficiaryID = 0;
      newBeneficiary.MembershipID = this.memberId;

      try {
        await this.$api.post('/beneficiary/UpdateBeneficiary', newBeneficiary);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Beneficiary was added',
        });
        this.getBeneficiaries();
      } catch (err) {
        console.log(err.message);
      }
    },

    async updateBeneficiary() {
      this.loading = true;
      try {
        this.formElements.forEach((el) => {
          this.selectedBeneficiary[el.FieldName] = el.Value;
        });
        await this.$api.post('/beneficiary/UpdateBeneficiary', this.selectedBeneficiary);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Beneficiary was updated',
        });
        this.getBeneficiaries();
      } catch (err) {
        console.log(err.message);
      }
    },

    async deleteBeneficiary() {
      this.isSidebarShown = false;
      try {
        await this.$api.delete(
          '/beneficiary/DeleteBeneficiary?Id=' + this.selectedBeneficiary.BeneficiaryID
        );

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Beneficiary was deleted',
        });
        this.getBeneficiaries();
      } catch (err) {
        console.log(err.message);
      }
    },

    async getBeneficiaries() {
      this.loading = true;
      try {
        let response = await this.$api.get(
          '/beneficiary/GetBeneficiaryList?membershipid=' + this.memberId + '&orderby=surname'
        );

        this.beneficiaries = response.data;
        this.loading = false;
      } catch (err) {
        console.error(err);
      }
    },

    async getBeneficiary(id) {
      try {
        let response = await this.$api.get('/beneficiary/GetBeneficiary?beneficiaryId=' + id);
        this.selectedBeneficiary = response.data;
        var data = response.data;

        if (!response.data) {
          const msg = 'Unable to get beneficiary';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        // match data with form fields
        if (data) Utils.setDataToFormElements(data, this.formElements);
      } catch (err) {
        console.error(err);
      }
    },

    async getForm(formName) {
      try {
        let response = await this.$api.get(
          '/datadictionary/GetFormElements?formName=' + formName + '&planId=' + this.currentPlanId
        );

        this.allElements = response.data;
        this.formElements = response.data.filter((f) => f.Visible == true);

        this.getBeneficiaries();
      } catch (err) {
        console.error(err);
      }
    },

    async getHeaders() {
      try {
        const response = await this.$api.get(
          `/datadictionary/GetGridHeaders?formName=Beneficiaries&planId=${this.currentPlanId}`
        );
        if (response.data.length) {
          const data = response.data.filter((item) => item.Visible);
          data.sort((a, b) => a.ColumbOrder - b.ColumbOrder);
          this.headers = data.map((item) => ({
            text: item.HeaderText,
            value: item.Datafield,
            align: item.Align.toLowerCase(),
            format: item.FieldFormat,
          }));
        } else {
          throw new Error('Unable to fetch table headers');
        }
      } catch (err) {
        console.log(err.message);
      }
    },
  },
};
</script>

<style scoped>
.beneficiaries {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 30px;
}

.sidebar {
  margin-bottom: 30px;
}

.sidebar h3 {
  margin-bottom: 20px;
}

.btnsContainer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
